import React from 'react';
import {
  SelectField,
  MenuItem,
} from 'material-ui';
import { translate as t } from 'admin-on-rest';
import TranslatableInput from './inputs/TranslatableInput';


class Heading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      elementValue: this.props.values ? this.props.values.element : '',
      sizeValue: this.props.values ? this.props.values.size : '',
    };
  }

  handleElementChange = (e, index, value) => {
    this.setState({ elementValue: value });
    const name = this.props.prefix ? `${this.props.prefix}.element` : 'element';
    this.props.onChange(name, this.props.id, value);
  }

  handleSizeChange = (e, index, value) => {
    this.setState({ sizeValue: value });
    const name = this.props.prefix ? `${this.props.prefix}.size` : 'size';
    this.props.onChange(name, this.props.id, value);
  }

  render() {
    const { translate, onChange, id, values } = this.props;
    return (
      <div>
        <TranslatableInput
          id={id}
          values={values && values.text}
          name="text"
          label={translate('website.headingText')}
          options={{ multiline: false }}
          onChange={(val) => onChange(this.props.prefix ? `${this.props.prefix}.text` : 'text', id, val)}
        />
        <span className="block-field">
          <SelectField
            name="size"
            id="size"
            fullWidth
            floatingLabelText={translate('website.size')}
            onChange={this.handleSizeChange}
            value={this.state.sizeValue}
          >
            <MenuItem value="small" primaryText="Small" />
            <MenuItem value="medium" primaryText="Medium" />
            <MenuItem value="large" primaryText="Large" />
          </SelectField>
        </span>
        <span className="block-field">
          <SelectField
            fullWidth
            name="element"
            floatingLabelText={translate('website.header')}
            onChange={this.handleElementChange}
            value={this.state.elementValue}
          >
            <MenuItem value="h1" primaryText={translate('website.header1')} />
            <MenuItem value="h2" primaryText={translate('website.header2')} />
            <MenuItem value="h3" primaryText={translate('website.header3')} />
            <MenuItem value="h4" primaryText={translate('website.header4')} />
          </SelectField>
        </span>
      </div>
    );
  }
}

export default t(Heading);
